var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62377 2H6.36359C6.21893 2 6.08019 2.05747 5.9779 2.15976C5.87561 2.26205 5.81814 2.40079 5.81814 2.54545C5.81814 2.69012 5.87561 2.82886 5.9779 2.93115C6.08019 3.03344 6.21893 3.09091 6.36359 3.09091H8.90323L5.95777 12.9091H3.09086C2.9462 12.9091 2.80746 12.9666 2.70517 13.0689C2.60288 13.1711 2.54541 13.3099 2.54541 13.4545C2.54541 13.5992 2.60288 13.7379 2.70517 13.8402C2.80746 13.9425 2.9462 14 3.09086 14H9.63632C9.78098 14 9.91972 13.9425 10.022 13.8402C10.1243 13.7379 10.1818 13.5992 10.1818 13.4545C10.1818 13.3099 10.1243 13.1711 10.022 13.0689C9.91972 12.9666 9.78098 12.9091 9.63632 12.9091H7.09668L10.0421 3.09091H12.909C13.0537 3.09091 13.1924 3.03344 13.2947 2.93115C13.397 2.82886 13.4545 2.69012 13.4545 2.54545C13.4545 2.40079 13.397 2.26205 13.2947 2.15976C13.1924 2.05747 13.0537 2 12.909 2H9.62377Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.f2693a9f7102526b3b111021bf657f37.svg";
export { ForwardRef as ReactComponent };